module.exports = __webpack_public_path__ + "static/media/green-tick-icon.212d1c3b.svg";